<template>
  <details
    class="lp-package-size-selector"
    :class="[shades.length == 1 ? 'singleVariant' : 'accordion arrow']"
  >
    <summary id="PACAKAGE_SIZE_SELECTOR" ref="accordion">
      <h2 class="text-small-em">{{ selectedPackageSize }}</h2>
      <svg
        class="lp-package-size-selector__toggle"
        aria-hidden="true"
        width="24"
        height="24"
      >
        <use href="/assets/sprite/icons.svg#arrow-black"></use>
      </svg>
    </summary>
    <div class="lp-details__contents" aria-labelledby="PACAKAGE_SIZE_SELECTOR">
      <ul class="lp-package-size-selector__list pt-xs">
        <li
          v-for="opt in packageOptions"
          :key="opt.Ean"
          :id="opt.Ean"
          role="option"
          :aria-selected="opt.selected"
          tabindex="0"
          @click="packageSelected(opt)"
          @keypress.space="packageSelected(opt)"
          @keypress.enter="packageSelected(opt)"
        >
          <span class="text-small-em"
            >{{ opt.DeclaredContent }} {{ opt.DeclaredContentUnit }}</span
          >
        </li>
      </ul>
    </div>
  </details>
</template>
<script>
export default {
  name: 'PackageSelector',
  data() {
    return {
      selectedPackageSize: '',
    };
  },
  props: {
    shades: {
      type: Array,
      required: true,
    },
  },
  computed: {
    packageOptions() {
      const opts = this.shades;
      return opts.map((o) => ({
        ...o,
        selected:
          o.DeclaredContent + ' ' + o.DeclaredContentUnit ===
          this.selectedPackageSize,
      }));
    },
  },
  mounted() {
    if (this.shades.length >= 1) {
      this.selectedPackageSize =
        this.shades[0].DeclaredContent +
        ' ' +
        this.shades[0].DeclaredContentUnit;
      let defaultVariantEan = this.shades[0].Ean;
      eventBus.$emit('package::selected', defaultVariantEan);
    }
  },
  methods: {
    packageSelected(opt) {
      this.selectedPackageSize =
        opt.DeclaredContent + ' ' + opt.DeclaredContentUnit;
      if (opt && opt.Tagging) {
        const eventData =
          typeof opt.Tagging === 'string'
            ? JSON.parse(opt.Tagging)
            : opt.Tagging;
        window.dataLayer.push(eventData);
      }
      eventBus.$emit('package::selected', opt.Ean);
      // Simulate a click on the summary so it animates close
      this.$refs.accordion.click();
    },
  },
};
</script>
<style lang="scss" src="./package-selector.scss"></style>
